<template>
    <div class="home"> 
        <!-- <homeHeader @getlocal='getlocal' id="nav"></homeHeader> -->
        <!-- banner --> 
        <bannerSearch ></bannerSearch>
         <!-- 知识应用 -->
        <knowledge id='knowledge'></knowledge>
        <!-- 学习专区 -->
        <study id='study' ></study>
        <!-- 专题服务 -->
        <!-- <subject id='subject'></subject> -->
        <!-- 热点新闻 -->
        <hotNews id='hotNews' ></hotNews>
        <!-- 特色资源 -->
        <resource id='resource' ></resource>
        <!-- 古籍定制服务 -->
        <ancientBooks id='ancientBooks'></ancientBooks>
        <!-- 学科定制服务 -->
       <customization id='customization'></customization>
       <!-- <homeFooter></homeFooter> -->
    </div>
</template>

<script> 
// import homeHeader from '../components/header.vue'
// import homeFooter from '../components/footer.vue'
import Cookies from 'js-cookie' 
import bannerSearch from './comps/banner_search.vue';
import hotNews from './homePage/comps/hot_news.vue';
import knowledge from './homePage/comps/knowledge.vue';
import study from './homePage/comps/study.vue';
import subject from './homePage/comps/subject.vue';
import ancientBooks from './homePage/comps/ancientBooks.vue';
import resource from './homePage/comps/resource.vue';
import customization from './homePage/comps/customization.vue';  
export default {
    components: {
        // homeHeader,
        // homeFooter,
        bannerSearch,
        hotNews,
        knowledge,
        study,
        subject,
        ancientBooks,
        resource,
        customization
    },
    data(){
        return {
            searchVal:'',  
            newsIndex:1, 
            
        }
    },
    created() {
    	//创建时执行跳转锚点位置。
		this.$nextTick(() => { 
			this.getlocal(); 
		}); 
	},
    mounted () {
        // console.log(this.source,'===')
    },
    methods: {
        toPage(path){
            let query={};
            let url= this.$router.resolve({
                path,
                query,
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
        //从我本地找到id 
		getlocal() {
			const selectId = localStorage.getItem('toId') || Cookies.get('toId');
			if (!selectId) return;
			const toElement = document.getElementById(selectId);
			if (toElement) {
				toElement.scrollIntoView(true);
			}
		}, 
    }
}
</script>

<style lang='less' > 
.home-region{
    width: 100%;
    padding:80px 0; 
    background: #fff;
}

a{
    display: block;
    width: 100%;
    height: 100%;
    position: relative; 
}
.region-cont{
    width: 1200px;
    margin: 0 auto; 
    .tit{
        font-size: 32px;
        padding:0 20px;
        font-weight: bold;
        width: 168px;
        margin: 0 auto 60px;
        position: relative;
        .tit-bottom{
            width: 100%;
            position: absolute;
            bottom:0;
            left: 0;
            height: 22px;
        }
        &.tit-blue{
            color: #0C55AA;
            .tit-bottom{
                background: url('../assets/images/home/blue-bg.png') no-repeat left bottom;
                background-size: cover;
            }
        }
        &.tit-gray{
            color: #333;
            .tit-bottom{
                background: url('../assets/images/home/gray-bg.png') no-repeat left bottom;
                background-size: cover;
            }
        }
        
    }
}
</style>